import { createRoutine } from 'redux-saga-routines';

// eslint-disable-next-line import/prefer-default-export
export const getManagers = createRoutine('GET_MANAGERS');
